import { DataGridPro } from '@mui/x-data-grid-pro';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { ADD_SHIPMENTS_QUERY_PARAMS } from 'pages/Shipments/params';
import * as React from 'react';
import { UseQueryResult } from '@tanstack/react-query';
import { WatchedShipment, WatchedShipmentResponse } from 'services/clients/watchList';
import { getColumns } from './columns';

interface Props {
  shipmentsQuery: UseQueryResult<WatchedShipmentResponse>;
}

export const Table: React.FC<Props> = (props) => {
  const { shipmentsQuery } = props;
  const [showTooltip, setShowTooltip] = React.useState('');
  const columns = React.useMemo(() => getColumns(showTooltip), [showTooltip]);
  const rows = shipmentsQuery.data?.results || [];

  const { searchParams, setSearchParams } = useCustomSearchParams(ADD_SHIPMENTS_QUERY_PARAMS);

  return (
    <DataGridPro
      autoHeight
      rows={rows}
      rowCount={shipmentsQuery.data?.count || 0}
      loading={shipmentsQuery.isLoading}
      columns={columns}
      getRowId={(r) => `${r.shipment.id}_${r.createdAt}`}
      rowHeight={32}
      headerHeight={32}
      disableSelectionOnClick
      pagination
      paginationMode="server"
      page={searchParams.page - 1}
      onPageChange={(page) => setSearchParams({ page: page + 1 })}
      pageSize={searchParams.pageSize}
      onPageSizeChange={(pageSize) => setSearchParams({ pageSize })}
      classes={{
        cellCheckbox: 'flex items-center justify-center',
        columnHeaders: 'bg-white shadow-sm border-none',
        columnHeader: 'bg-white',
        columnHeaderCheckbox: 'bg-white shadow-sm py-4',
        columnHeaderTitle: 'px-2 py-4',
        cell: 'flex items-start flex-col border-none',
        root: 'bg-white border-gray-200',
        row: 'border-b border-gray-200',
        main: 'bg-white',
        footerContainer: 'flex flex-row-reverse flex-grow border-none bg-white',
      }}
      getRowClassName={(params) => {
        const watch: WatchedShipment = params.row;
        if (watch.trackingStatus === 'LOCATING') {
          return 'bg-gray-200';
        }
        return '';
      }}
      onColumnHeaderOver={(params) => setShowTooltip(params.field)}
      onColumnHeaderOut={() => setShowTooltip('')}
      components={{
        NoRowsOverlay: () => (
          <div className="text-center text-gray-400 flex items-center justify-center w-full h-full">
            No shipments tracked
          </div>
        ),
      }}
      sx={{
        '.MuiDataGrid-cell:nth-of-type(1)': {
          borderRight: 'none',
        },
        '.MuiDataGrid-columnHeader:nth-of-type(1)': {
          borderRight: 'none',
        },
        '.MuiDataGrid-cell': {
          borderBottom: 'none',
        },
      }}
    />
  );
};
Table.displayName = 'Shipments.AddContainers.RecentlyAdded.Table';
